<template>
    <Component :is="sliceVariationComponent" v-bind="props" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {ProfilesSlice} from '@prismicio-types';
    import ProfilesDefault from './variations/ProfilesDefault.vue';
    import ProfilesGrid from './variations/ProfilesGrid.vue';
    import ProfileWithShapes from './variations/ProfileWithShapes.vue';
    import {getSliceVariationComponent} from '../../utils/sliceVariations';

    const props = defineProps(getSliceComponentProps<ProfilesSlice>(['slice', 'index', 'slices', 'context']));

    const variationComponents = {
        default: ProfilesDefault,
        profilesWithShapes: ProfileWithShapes,
        profilesGrid: ProfilesGrid,
    };

    const sliceVariationComponent = computed(() => getSliceVariationComponent(props.slice, variationComponents));
</script>
